export default __webpack_public_path__ + "static/media/social-twitter.5b155e4b.svg";